__turbopack_context__.v({
  "className": "space_grotesk_fa61ca96-module__fm6kLG__className",
  "variable": "space_grotesk_fa61ca96-module__fm6kLG__variable",
});
